import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

class AssistantService {
  async ask(tenantId: string, question: string): Promise<string> {
    try {
      const response = await authenticatedInstance.post<{ answer: string }>(
        `/assistant/tenant/${encodeURIComponent(tenantId)}/chat`,
        { question },
      );
      return response.data.answer;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'Assistant request failed'));
    }
  }
}

export const assistantService = new AssistantService();